module.exports = __webpack_public_path__ + "img/19a-lrn-spt-cat-2-icon-def.98f9bab7.svg";